import { useEffect, useState } from 'react';
import { getAccounts } from '../../../../services/PRM/PRMAccountsService';
import type { Account } from '../accountsTypes';

const useAccountData = () => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadAccounts = async () => {
      try {
        const data = await getAccounts();
        if (isMounted) setAccounts(data);
      } catch {
        if (isMounted) setError('Unable to load accounts. Please try again later.');
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadAccounts();
    return () => {
      isMounted = false;
    };
  }, []);

  return { accounts, isLoading, error };
};

export default useAccountData;
